export const handleBeforeUnload = (e: BeforeUnloadEvent) => {
  e.preventDefault();
  const message = 'There are unsaved changes. Exit without saving?';
  e.returnValue = message;
  return message;
};
